import { createSlice } from "@reduxjs/toolkit";

const apiStatusSlice = createSlice({
  name: "apiStatus",
  initialState: {},
  reducers: {
    updateApiStatus: (state, action) => {
      const { tableName, status } = action.payload;
      state[tableName] = status;
    },
    // Batch update multiple API statuses at once
    setAllApiStatus: (state, action) => {
      const { statuses } = action.payload;
      Object.entries(statuses).forEach(([tableName, status]) => {
        state[tableName] = status;
      });
    },
    clearApiStatus: (state) => {
      return {};
    },
  },
});

export const { updateApiStatus, setAllApiStatus, clearApiStatus } = apiStatusSlice.actions;
export const selectApiStatus = (state) => state.apiStatus;
export default apiStatusSlice.reducer;
